module.exports = __webpack_public_path__ + "static/Global_Delivery_centre-77afce1f10a414b6d48a6edf7605ade2.png";